import { RefreshCw } from "lucide-react";
import { FC, useEffect, useRef } from "react";

import { Button } from "@/components/ui/button";
import { LGT_VERIFY_URL } from "@/lib/env";
import { PreviewParams } from "@/lib/preview";

interface IFrameEvent {
  data: {
    ready: boolean;
  };
}

type Props = {
  params: PreviewParams;
};

export const PreviewExperience: FC<Props> = ({ params }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage({ tag: params }, "*");
    }

    const handleMessage = (event: IFrameEvent) => {
      if (event.data.ready && iframeRef.current?.contentWindow) {
        iframeRef.current.contentWindow.postMessage({ tag: params }, "*");
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [params]);

  const refreshPreview = () => {
    if (iframeRef.current) {
      iframeRef.current.src = LGT_VERIFY_URL;
    }
  };

  return (
    <div className="flex-1 max-w-[430px] min-w-[375px]">
      <div className="w-full rounded-3xl bg-secondary overflow-hidden border aspect-9/16">
        <iframe
          id="preview"
          ref={iframeRef}
          src={LGT_VERIFY_URL}
          title="Preview"
          className="size-full"
        />
      </div>

      <Button className="w-full mt-3" variant="ghost" onClick={refreshPreview}>
        <RefreshCw /> Refresh Preview
      </Button>
    </div>
  );
};
